import React from 'react';

const LabelLogin = () => {
  return (
    <div className='label-login__item'>
      <p>" Your Best Platform To Manage Your Favorite Recipes "</p>
    </div>
  );
};

export default LabelLogin;
